var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c(
        "job-preview-content-outline",
        _vm._g(
          {
            attrs: {
              title: "雇用形態",
              "comment-highlights": _vm.getCommentHighlights(
                _vm.targetIdMap.requirements.employment
              ),
              "highlight-mode": _vm.highlightMode,
              "target-id": _vm.targetIdMap.requirements.employment,
              value: _vm.requirements.employment.join(" "),
              "data-test": "employment",
            },
            scopedSlots: _vm._u(
              [
                _vm.requirements.employmentRemarks
                  ? {
                      key: "supplement",
                      fn: function () {
                        return [
                          _c(
                            "job-preview-content",
                            _vm._g(
                              {
                                attrs: {
                                  "comment-highlights":
                                    _vm.getCommentHighlights(
                                      _vm.targetIdMap.requirements
                                        .employmentRemarks
                                    ),
                                  "text-count-mode": _vm.textCountMode,
                                  "highlight-mode": _vm.highlightMode,
                                  "text-counts": [
                                    _vm.getTextCount(
                                      "試用期間の雇用形態備考",
                                      _vm.requirements.employmentRemarks,
                                      _vm.targetIdMap.requirements
                                        .employmentRemarks
                                    ),
                                  ],
                                  "target-id":
                                    _vm.targetIdMap.requirements
                                      .employmentRemarks,
                                  value: _vm.requirements.employmentRemarks,
                                  "data-test": "employmentRemarks",
                                },
                              },
                              _vm.$listeners
                            )
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.requirements.regular
                  ? {
                      key: "sub",
                      fn: function () {
                        return [
                          _c(
                            "job-preview-content-sub",
                            _vm._g(
                              {
                                attrs: {
                                  title: "正社員登用について",
                                  "comment-highlights":
                                    _vm.getCommentHighlights(
                                      _vm.targetIdMap.requirements.regular
                                    ),
                                  "text-count-mode": _vm.textCountMode,
                                  "highlight-mode": _vm.highlightMode,
                                  "text-counts": [
                                    _vm.getTextCount(
                                      "正社員登用について",
                                      _vm.requirements.regular,
                                      _vm.targetIdMap.requirements.regular
                                    ),
                                  ],
                                  "target-id":
                                    _vm.targetIdMap.requirements.regular,
                                  value: _vm.requirements.regular,
                                  "data-test": "regular",
                                },
                              },
                              _vm.$listeners
                            )
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "job-preview-content-outline",
        _vm._g(
          {
            attrs: {
              title: "給与",
              "comment-highlights": _vm.getCommentHighlights(
                _vm.targetIdMap.requirements.salary
              ),
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "text-counts": [
                _vm.getTextCount(
                  "給与",
                  _vm.requirements.salary,
                  _vm.targetIdMap.requirements.salary
                ),
              ],
              "target-id": _vm.targetIdMap.requirements.salary,
              value: _vm.requirements.salary,
              "data-test": "salary",
            },
            scopedSlots: _vm._u(
              [
                _vm.requirements.salaryEx ||
                (_vm.requirements.isBulkRegistrationAddress &&
                  _vm.isMultiLineValue)
                  ? {
                      key: "sub",
                      fn: function () {
                        return [
                          _vm.requirements.salaryEx
                            ? _c(
                                "job-preview-content-sub",
                                _vm._g(
                                  {
                                    attrs: {
                                      title: "給与例",
                                      "comment-highlights":
                                        _vm.getCommentHighlights(
                                          _vm.targetIdMap.requirements.salaryEx
                                        ),
                                      "text-count-mode": _vm.textCountMode,
                                      "highlight-mode": _vm.highlightMode,
                                      "text-counts": [
                                        _vm.getTextCount(
                                          "給与例",
                                          _vm.requirements.salaryEx,
                                          _vm.targetIdMap.requirements.salaryEx
                                        ),
                                      ],
                                      "target-id":
                                        _vm.targetIdMap.requirements.salaryEx,
                                      value: _vm.requirements.salaryEx,
                                      "data-test": "salaryEx",
                                    },
                                  },
                                  _vm.$listeners
                                )
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.requirements.isBulkRegistrationAddress &&
                          _vm.isMultiLineValue
                            ? _c(
                                "job-preview-content-sub",
                                _vm._g(
                                  {
                                    attrs: {
                                      title: "勤務地別給与",
                                      "comment-highlights":
                                        _vm.getCommentHighlights(
                                          _vm.targetIdMap.requirements
                                            .combinedAllSalaryBulkPlace
                                        ),
                                      "highlight-mode": _vm.highlightMode,
                                      "text-counts": [
                                        _vm.getTextCount(
                                          "勤務地別給与",
                                          _vm.requirements
                                            .combinedAllSalaryBulkPlace,
                                          _vm.targetIdMap.requirements
                                            .combinedAllSalaryBulkAddress
                                        ),
                                      ],
                                      "target-id":
                                        _vm.targetIdMap.requirements
                                          .combinedAllSalaryBulkPlace,
                                      value:
                                        _vm.requirements
                                          .combinedAllSalaryBulkPlace,
                                      "data-test": "combinedAllSalaryBulkPlace",
                                    },
                                  },
                                  _vm.$listeners
                                )
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "job-preview-content-outline",
        _vm._g(
          {
            attrs: {
              title: "勤務地",
              "comment-highlights": _vm.getCommentHighlights(
                _vm.targetIdMap.requirements.place
              ),
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "text-counts": [
                _vm.getTextCount(
                  "勤務地",
                  _vm.requirements.place,
                  _vm.targetIdMap.requirements.place
                ),
              ],
              "target-id": _vm.targetIdMap.requirements.place,
              value: _vm.requirements.place,
              "data-test": "place",
            },
            scopedSlots: _vm._u([
              {
                key: "sub",
                fn: function () {
                  return [
                    _vm.requirements.transportation
                      ? _c(
                          "job-preview-content-sub",
                          _vm._g(
                            {
                              attrs: {
                                title: "詳細・交通",
                                "comment-highlights": _vm.getCommentHighlights(
                                  _vm.targetIdMap.requirements.transportation
                                ),
                                "text-count-mode": _vm.textCountMode,
                                "highlight-mode": _vm.highlightMode,
                                "text-counts": [
                                  _vm.getTextCount(
                                    "詳細・交通",
                                    _vm.requirements.transportation,
                                    _vm.targetIdMap.requirements.transportation
                                  ),
                                ],
                                "target-id":
                                  _vm.targetIdMap.requirements.transportation,
                                value: _vm.requirements.transportation,
                                "data-test": "transportation",
                              },
                            },
                            _vm.$listeners
                          )
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.requirements.transfer
                      ? _c(
                          "job-preview-content-sub",
                          _vm._g(
                            {
                              attrs: {
                                title: "転勤の可能性",
                                "comment-highlights": _vm.getCommentHighlights(
                                  _vm.targetIdMap.requirements.transfer
                                ),
                                "text-count-mode": _vm.textCountMode,
                                "highlight-mode": _vm.highlightMode,
                                "text-counts": [
                                  _vm.getTextCount(
                                    "転勤の可能性",
                                    _vm.requirements.transfer,
                                    _vm.targetIdMap.requirements.transfer
                                  ),
                                ],
                                "target-id":
                                  _vm.targetIdMap.requirements.transfer,
                                value: _vm.requirements.transfer,
                                "data-test": "transfer",
                              },
                            },
                            _vm.$listeners
                          )
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.requirements.isBulkRegistrationAddress &&
                    _vm.requirements.combinedAllBulkPlace
                      ? _c(
                          "job-preview-content-sub-work-location",
                          _vm._g(
                            {
                              attrs: {
                                "comment-highlights": _vm.getCommentHighlights(
                                  _vm.targetIdMap.requirements
                                    .combinedAllBulkPlace
                                ),
                                "highlight-mode": _vm.highlightMode,
                                value: _vm.requirements.combinedAllBulkPlace,
                                title: "勤務地一覧",
                                "is-bulk-registration-address":
                                  _vm.requirements.isBulkRegistrationAddress,
                                "place-id":
                                  _vm.targetIdMap.requirements
                                    .combinedAllBulkPlace,
                                "data-test": "combinedAllBulkPlace",
                              },
                            },
                            _vm.$listeners
                          )
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.requirements.isBulkRegistrationAddress
                      ? _c(
                          "job-preview-content-sub-work-location",
                          _vm._g(
                            {
                              attrs: {
                                "comment-highlights": _vm.getCommentHighlights(
                                  _vm.targetIdMap.requirements.workLocation
                                ),
                                "highlight-mode": _vm.highlightMode,
                                value: _vm.requirements.workLocation,
                                title: "勤務地エリア",
                                "place-id":
                                  _vm.targetIdMap.requirements.workLocation,
                                "data-test": "workLocation",
                              },
                            },
                            _vm.$listeners
                          )
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "job-preview-content-outline",
        _vm._g(
          {
            attrs: {
              title: "応募資格",
              "comment-highlights": _vm.getCommentHighlights(
                _vm.targetIdMap.requirements.requiredSkill
              ),
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "text-counts": [
                _vm.getTextCount(
                  "応募資格",
                  _vm.requirements.requiredSkill,
                  _vm.targetIdMap.requirements.requiredSkill
                ),
              ],
              "target-id": _vm.targetIdMap.requirements.requiredSkill,
              value: _vm.requirements.requiredSkill,
              "data-test": "requiredSkill",
            },
            scopedSlots: _vm._u([
              {
                key: "sub",
                fn: function () {
                  return [
                    _vm.requirements.welcomeSkill
                      ? _c(
                          "job-preview-content-sub",
                          _vm._g(
                            {
                              attrs: {
                                title: "あると望ましい経験・能力",
                                "comment-highlights": _vm.getCommentHighlights(
                                  _vm.targetIdMap.requirements.welcomeSkill
                                ),
                                "text-count-mode": _vm.textCountMode,
                                "highlight-mode": _vm.highlightMode,
                                "text-counts": [
                                  _vm.getTextCount(
                                    "あると望ましい経験・能力",
                                    _vm.requirements.welcomeSkill,
                                    _vm.targetIdMap.requirements.welcomeSkill
                                  ),
                                ],
                                "target-id":
                                  _vm.targetIdMap.requirements.welcomeSkill,
                                value: _vm.requirements.welcomeSkill,
                                "data-test": "welcomeSkill",
                              },
                            },
                            _vm.$listeners
                          )
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.requirements.recruitExample
                      ? _c(
                          "job-preview-content-sub",
                          _vm._g(
                            {
                              attrs: {
                                title: "過去に採用した転職者例",
                                "comment-highlights": _vm.getCommentHighlights(
                                  _vm.targetIdMap.requirements.recruitExample
                                ),
                                "text-count-mode": _vm.textCountMode,
                                "highlight-mode": _vm.highlightMode,
                                "text-counts": [
                                  _vm.getTextCount(
                                    "過去に採用した転職者例",
                                    _vm.requirements.recruitExample,
                                    _vm.targetIdMap.requirements.recruitExample
                                  ),
                                ],
                                "target-id":
                                  _vm.targetIdMap.requirements.recruitExample,
                                value: _vm.requirements.recruitExample,
                                "data-test": "recruitExample",
                              },
                            },
                            _vm.$listeners
                          )
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm.isShow.post
        ? _c(
            "job-preview-content-outline",
            _vm._g(
              {
                attrs: {
                  title: "配属部署",
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.requirements.post
                  ),
                  "text-count-mode": _vm.textCountMode,
                  "highlight-mode": _vm.highlightMode,
                  "text-counts": [
                    _vm.getTextCount(
                      "配属部署",
                      _vm.requirements.post,
                      _vm.targetIdMap.requirements.post
                    ),
                  ],
                  "target-id": _vm.targetIdMap.requirements.post,
                  value: _vm.requirements.post,
                  "data-test": "post",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "sub",
                      fn: function () {
                        return [
                          _vm.requirements.ageRatio
                            ? _c(
                                "job-preview-content-sub",
                                _vm._g(
                                  {
                                    attrs: {
                                      title: "年齢構成",
                                      "comment-highlights":
                                        _vm.getCommentHighlights(
                                          _vm.targetIdMap.requirements.ageRatio
                                        ),
                                      "text-count-mode": _vm.textCountMode,
                                      "highlight-mode": _vm.highlightMode,
                                      "text-counts": [
                                        _vm.getTextCount(
                                          "年齢構成",
                                          _vm.requirements.ageRatio,
                                          _vm.targetIdMap.requirements.ageRatio
                                        ),
                                      ],
                                      "target-id":
                                        _vm.targetIdMap.requirements.ageRatio,
                                      value: _vm.requirements.ageRatio,
                                      "data-test": "ageRatio",
                                    },
                                  },
                                  _vm.$listeners
                                )
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.requirements.sexRatio
                            ? _c(
                                "job-preview-content-sub",
                                _vm._g(
                                  {
                                    attrs: {
                                      title: "男女比",
                                      "comment-highlights":
                                        _vm.getCommentHighlights(
                                          _vm.targetIdMap.requirements.sexRatio
                                        ),
                                      "text-count-mode": _vm.textCountMode,
                                      "highlight-mode": _vm.highlightMode,
                                      "text-counts": [
                                        _vm.getTextCount(
                                          "男女比",
                                          _vm.requirements.sexRatio,
                                          _vm.targetIdMap.requirements.sexRatio
                                        ),
                                      ],
                                      "target-id":
                                        _vm.targetIdMap.requirements.sexRatio,
                                      value: _vm.requirements.sexRatio,
                                      "data-test": "sexRatio",
                                    },
                                  },
                                  _vm.$listeners
                                )
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2436424212
                ),
              },
              _vm.$listeners
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "job-preview-content-outline",
        _vm._g(
          {
            attrs: {
              title: "勤務時間",
              "comment-highlights": _vm.getCommentHighlights(
                _vm.targetIdMap.requirements.officeHours
              ),
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "text-counts": [
                _vm.getTextCount(
                  "勤務時間",
                  _vm.requirements.officeHours,
                  _vm.targetIdMap.requirements.officeHours
                ),
              ],
              "target-id": _vm.targetIdMap.requirements.officeHours,
              value: _vm.requirements.officeHours,
              "data-test": "officeHours",
            },
            scopedSlots: _vm._u([
              {
                key: "sub",
                fn: function () {
                  return [
                    _vm.requirements.overTime
                      ? _c(
                          "job-preview-content-sub",
                          _vm._g(
                            {
                              attrs: {
                                title: "残業について",
                                "comment-highlights": _vm.getCommentHighlights(
                                  _vm.targetIdMap.requirements.overTime
                                ),
                                "text-count-mode": _vm.textCountMode,
                                "highlight-mode": _vm.highlightMode,
                                "text-counts": [
                                  _vm.getTextCount(
                                    "残業について",
                                    _vm.requirements.overTime,
                                    _vm.targetIdMap.requirements.overTime
                                  ),
                                ],
                                "target-id":
                                  _vm.targetIdMap.requirements.overTime,
                                value: _vm.requirements.overTime,
                                "data-test": "overTime",
                              },
                            },
                            _vm.$listeners
                          )
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm.requirements.mother
        ? _c(
            "job-preview-content-outline",
            _vm._g(
              {
                attrs: {
                  title: "育児と両立しやすい",
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.requirements.mother
                  ),
                  "text-count-mode": _vm.textCountMode,
                  "highlight-mode": _vm.highlightMode,
                  "text-counts": [
                    _vm.getTextCount(
                      "育児と両立しやすい",
                      _vm.requirements.mother,
                      _vm.targetIdMap.requirements.mother
                    ),
                  ],
                  "target-id": _vm.targetIdMap.requirements.mother,
                  value: _vm.requirements.mother,
                  "data-test": "mother",
                },
              },
              _vm.$listeners
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "job-preview-content-outline",
        _vm._g(
          {
            attrs: {
              title: "休日休暇",
              "comment-highlights": _vm.getCommentHighlights(
                _vm.targetIdMap.requirements.vacation
              ),
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "text-counts": [
                _vm.getTextCount(
                  "休日休暇",
                  _vm.requirements.vacation,
                  _vm.targetIdMap.requirements.vacation
                ),
              ],
              "target-id": _vm.targetIdMap.requirements.vacation,
              value: _vm.requirements.vacation,
              "data-test": "vacation",
            },
            scopedSlots: _vm._u(
              [
                _vm.requirements.maternity
                  ? {
                      key: "sub",
                      fn: function () {
                        return [
                          _c(
                            "job-preview-content-sub",
                            _vm._g(
                              {
                                attrs: {
                                  title: "産休育休活用例",
                                  "comment-highlights":
                                    _vm.getCommentHighlights(
                                      _vm.targetIdMap.requirements.maternity
                                    ),
                                  "text-count-mode": _vm.textCountMode,
                                  "highlight-mode": _vm.highlightMode,
                                  "text-counts": [
                                    _vm.getTextCount(
                                      "産休育休活用例",
                                      _vm.requirements.maternity,
                                      _vm.targetIdMap.requirements.maternity
                                    ),
                                  ],
                                  "target-id":
                                    _vm.targetIdMap.requirements.maternity,
                                  value: _vm.requirements.maternity,
                                  "data-test": "maternity",
                                },
                              },
                              _vm.$listeners
                            )
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "job-preview-content-outline",
        _vm._g(
          {
            attrs: {
              title: "待遇・福利厚生・その他",
              "comment-highlights": _vm.getCommentHighlights(
                _vm.targetIdMap.requirements.condition
              ),
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "text-counts": [
                _vm.getTextCount(
                  "待遇・福利厚生・その他",
                  _vm.requirements.condition,
                  _vm.targetIdMap.requirements.condition
                ),
              ],
              "target-id": _vm.targetIdMap.requirements.condition,
              value: _vm.requirements.condition,
              "data-test": "condition",
            },
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }